import type { LoginResult } from '@zola-helpers/client/dist/es/redux/auth/authActions';

export enum AuthState {
  LOGIN = 'LOGIN',
  SIGNUP = 'SIGNUP',
  FORGOT = 'FORGOT',
  TWOFA = 'TWOFA',
}

// different types of minimal auth forms
export enum MinimalAuthFormType {
  SOCIAL_SIGNUP = 'socialSignup',
  EMAIL_SIGNUP = 'emailSignup',
  LOGIN = 'login',
}

export enum HostName {
  LOCALHOST = 'localhost',
  LOCALHOST_TEST = 'local.test',
  QA = 'qa.zola.com',
  QA_HOMESTORE = 'qa-homestore.zola.com',
  PROD = 'www.zola.com',
  PROD_HOMESTORE = 'homestore.zola.com',
}

export type CommonAuthFormProps = {
  authState: AuthState;
  hideVendorLogin?: boolean;
  setAuthState: (type: AuthState) => void;
  onAny200Login: (data: LoginResult, email?: string) => void;
  signupCallback: () => void;
  onClickSignup: () => void;
  passwordInputType?: string;
  onTogglePasswordVisibility?: () => void;
  useRefactoredRecaptcha?: boolean;
  isMidInquiryFlowAuth?: boolean;
  submitDisabled?: boolean;
};

export type AuthFormV1Props = CommonAuthFormProps;

export type MinimalAuthFormValues = {
  email: string;
  password: string;
  timezone?: string;
  fullName?: string;

  /**
   * Optional first name to pass through to the create user request.  If
   * includeNameInput is set on the minimal auth form, the full name will be
   * used instead.
   *
   * This value is not shown to the user, it simply allows us to pass a name
   * captured in a step prior to the auth modal showing to the create user request.
   */
  firstName?: string;

  /**
   * Optional last name to pass through to the create user request.  If
   * includeNameInput is set on the minimal auth form, the full name will be
   * used instead.
   *
   * This value is not shown to the user, it simply allows us to pass a name
   * captured in a step prior to the auth modal showing to the create user request.
   */
  lastName?: string;
};

export type MinimalAuthFormProps = CommonAuthFormProps & {
  authHed?: string;
  loginCTA?: string;
  signupCTA?: string;
  includeNameInput?: boolean;
  initialMinimalAuthFormState?: MinimalAuthFormType;

  initialValues?: Omit<Partial<MinimalAuthFormValues>, 'password'>;

  onClickLogin: () => void;
};
